<template>
  <div>
    <b-row>
      <!-- <b-col cols="10" class="mb-2">
        <h5 class="mb-0">Documentos</h5>

        <small class="text-muted">Agregar los documentos necesarios</small>
      </b-col> -->

      <b-col class="d-flex justify-content-end align-text-bottom">
        <b-button class="mb-1" variant="outline-primary" @click="redirectToMSP">
          Solicitar MSP
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-card class="col-12" style="border: 1px solid #c9c9c9">
        <div class="row d-flex align-items-center my-2" style="text-decoration: underline">
          <h6 class="col-2 text-center">Tipo/Documento</h6>
          <h6 class="col-1 text-center">Ver Actual</h6>
          <h6 class="col-7 text-center">Subir Nuevo</h6>
        </div>
        <div v-if="esDerivado || esimagenDerivada || esLaboratorioDerivado" class="row d-flex align-items-center my-2">
          <h6 class="col-2">Form 007</h6>
          <div>
            <a v-if="oldfile007" class="col-1 mr-1 bg-success text-white text-center rounded"
              @click="descargarDocumento('007')">Descargar</a>
            <a v-else class="col-1 mr-1 bg-secondary text-white text-center rounded">No disponible</a>
          </div>
          <b-form-file class="col-7" v-model="files.f007" @change="onFileChange($event, '007')"
            :state="Boolean(files.f007)" placeholder="elija un archivo o arrastre aqui..."
            drop-placeholder="Drop file here..." browse-text="Buscar..." accept=".pdf" />
          <b-button v-if="files.f007" class="ml-1" variant="danger" size="sm" @click="files.f007 = null">
            <i class="fa-solid fa-trash"></i>
          </b-button>
          <a class="ml-2" v-if="file007 && files.f007" @click="openModalVer(file007)">Ver nuevo</a>
        </div>
        <div v-if="esDerivado || esimagenDerivada || esLaboratorioDerivado" class="row d-flex align-items-center my-2">
          <h6 class="col-2">Derivación</h6>
          <div>
            <a v-if="oldfilederivacion" class="col-1 mr-1 bg-success text-white text-center rounded"
              @click="descargarDocumento('der')">Descargar</a>
            <a v-else class="col-1 mr-1 bg-secondary text-white text-center rounded">No disponible</a>
          </div>
          <b-form-file class="col-7" v-model="files.derivacion" @change="onFileChange($event, 'der')"
            :state="Boolean(files.derivacion)" placeholder="elija un archivo o arrastre aqui..."
            drop-placeholder="Drop file here..." browse-text="Buscar..." accept=".pdf" />
          <b-button v-if="files.derivacion" class="ml-1" variant="danger" size="sm" @click="files.derivacion = null">
            <i class="fa-solid fa-trash"></i>
          </b-button>
          <a class="ml-2" v-if="filederivacion && files.derivacion" @click="openModalVer(filederivacion)">Ver nuevo</a>
        </div>

        <div v-if="esDerivado || esimagenDerivada || esLaboratorioDerivado" class="row d-flex align-items-center my-2">
          <h6 class="col-2">Código de Derivación</h6>
          <div>
            <a v-if="oldfilecodDerivacion" class="col-1 mr-1 bg-success text-white text-center rounded"
              @click="descargarDocumento('codder')">Descargar</a>
            <a v-else class="col-1 mr-1 bg-secondary text-white text-center rounded">No disponible</a>
          </div>
          <b-form-file class="col-7" v-model="files.codigoDerivacion" @change="onFileChange($event, 'codder')"
            :state="Boolean(files.codigoDerivacion)" placeholder="elija un archivo o arrastre aqui..."
            drop-placeholder="Drop file here..." browse-text="Buscar..." accept=".pdf" />
          <b-button v-if="files.codigoDerivacion" class="ml-1" variant="danger" size="sm"
            @click="files.codigoDerivacion = null">
            <i class="fa-solid fa-trash"></i>
          </b-button>
          <a class="ml-2" v-if="filecodDerivacion && files.codigoDerivacion"
            @click="openModalVer(filecodDerivacion)">Ver nuevo</a>
        </div>
        <div v-if="esimagenDerivada" class="row d-flex align-items-center my-2">
          <h6 class="col-2">Solicitud de Imagen/ Form 12A</h6>
          <div>
            <a v-if="oldfileSolicitudImagen" class="col-1 mr-1 bg-success text-white text-center rounded"
              @click="descargarDocumento('solimg')">Descargar</a>
            <a v-else class="col-1 mr-1 bg-secondary text-white text-center rounded">No disponible</a>
          </div>
          <b-form-file class="col-7" v-model="files.solicitudImagen" @change="onFileChange($event, 'solimg')"
            :state="Boolean(files.solicitudImagen)" placeholder="elija un archivo o arrastre aqui..."
            drop-placeholder="Drop file here..." browse-text="Buscar..." accept=".pdf" />
          <b-button v-if="files.solicitudImagen" class="ml-1" variant="danger" size="sm"
            @click="files.solicitudImagen = null">
            <i class="fa-solid fa-trash"></i>
          </b-button>
          <a class="ml-2" v-if="fileSolicitudImagen && files.solicitudImagen"
            @click="openModalVer(fileSolicitudImagen)">Ver nuevo</a>
        </div>
        <div v-if="esLaboratorioDerivado" class="row d-flex align-items-center my-2">
          <h6 class="col-2">Solicitud de Laboratorio/ Form 10A</h6>
          <div>
            <a v-if="oldfileSolicitudLaboratorio" class="col-1 mr-1 bg-success text-white text-center rounded"
              @click="descargarDocumento('sollab')">Descargar</a>
            <a v-else class="col-1 mr-1 bg-secondary text-white text-center rounded">No disponible</a>
          </div>
          <b-form-file class="col-7" v-model="files.solicitudLaboratorio" @change="onFileChange($event, 'sollab')"
            :state="Boolean(files.solicitudLaboratorio)" placeholder="elija un archivo o arrastre aqui..."
            drop-placeholder="Drop file here..." browse-text="Buscar..." accept=".pdf" />
          <b-button v-if="files.solicitudLaboratorio" class="ml-1" variant="danger" size="sm"
            @click="files.solicitudLaboratorio = null">
            <i class="fa-solid fa-trash"></i>
          </b-button>
          <a class="ml-2" v-if="fileSolicitudLaboratorio && files.solicitudLaboratorio"
            @click="openModalVer(fileSolicitudLaboratorio)">Ver nuevo</a>
        </div>

        <div class="row d-flex align-items-center my-2">
          <h6 class="col-2">
            (MSP Paciente)
            {{ paciente && paciente.text ? paciente.text : pacientetext }}
          </h6>
          <div>
            <a v-if="oldfileUrlmspPaciente" class="col-1 mr-1 bg-success text-white text-center rounded"
              @click="descargarDocumento('msppac')">Descargar</a>
            <a v-else class="col-1 mr-1 bg-secondary text-white text-center rounded">No disponible</a>
          </div>
          <b-form-file class="col-7" v-model="files.mspPaciente" @change="onFileChange($event, 'msp')"
            :state="Boolean(files.mspPaciente)" placeholder="elija un archivo o arrastre aqui..."
            drop-placeholder="Drop file here..." browse-text="Buscar..." accept=".pdf" />
          <b-button v-if="files.mspPaciente" class="ml-1" variant="danger" size="sm" @click="files.mspPaciente = null">
            <i class="fa-solid fa-trash"></i>
          </b-button>
          <a class="ml-2" v-if="fileUrlmspPaciente && files.mspPaciente" @click="openModalVer(fileUrlmspPaciente)">Ver
            nuevo</a>
        </div>

        <div v-if="mspTitulares.length > 0">
          <div v-for="(persona, index) in mspTitulares">
            <div v-if="persona" class="row d-flex align-items-center my-2">
              <h6 class="col-2">
                (MSP Titular {{ index + 1 }}) {{ persona.primerApellido }}
                {{ persona.primerNombre }} {{ persona.identificacion }}
              </h6>
              <div v-if="index + 1 === 1">
                <a v-if="oldfileUrlmspTitular1" class="col-1 mr-1 bg-success text-white text-center rounded"
                  @click="descargarDocumento('msptit1')">Descargar</a>
                <a v-else class="col-1 mr-1 bg-secondary text-white text-center rounded">No disponible</a>
              </div>
              <div v-if="index + 1 === 2">
                <a v-if="oldfileUrlmspTitular2" class="col-1 mr-1 bg-success text-white text-center rounded"
                  @click="descargarDocumento('msptit2')">Descargar</a>
                <a v-else class="col-1 mr-1 bg-secondary text-white text-center rounded">No disponible</a>
              </div>
              <div v-if="index + 1 === 3">
                <a v-if="oldfileUrlmspTitular3" class="col-1 mr-1 bg-success text-white text-center rounded"
                  @click="descargarDocumento('msptit3')">Descargar</a>
                <a v-else class="col-1 mr-1 bg-secondary text-white text-center rounded">No disponible</a>
              </div>

              <b-form-file class="col-7" v-model="files['mspTitular' + (index + 1)]"
                @change="onFileChange($event, 'mspt' + (index + 1))" :state="Boolean(files['mspTitular' + (index + 1)])"
                placeholder="Elija un archivo o arrastre aquí..." drop-placeholder="Drop file here..."
                browse-text="Buscar..." accept=".pdf" />

              <!-- Botón para eliminar el archivo si existe -->
              <div v-if="index + 1 === 1">
                <b-button v-if="files.mspTitular1" class="ml-1" variant="danger" size="sm"
                  @click="files.mspTitular1 = null">
                  <i class="fa-solid fa-trash"></i>
                </b-button>
                <a class="ml-2" v-if="fileUrlmspTitular1 && files.mspTitular1"
                  @click="openModalVer(fileUrlmspTitular1)">Ver nuevo</a>
              </div>
              <div v-if="index + 1 === 2">
                <b-button v-if="files.mspTitular2" class="ml-1" variant="danger" size="sm"
                  @click="files.mspTitular2 = null">
                  <i class="fa-solid fa-trash"></i>
                </b-button>
                <a class="ml-2" v-if="fileUrlmspTitular2 && files.mspTitular2"
                  @click="openModalVer(fileUrlmspTitular2)">Ver nuevo</a>
              </div>
              <div v-if="index + 1 === 3">
                <b-button v-if="files.mspTitular3" class="ml-1" variant="danger" size="sm"
                  @click="files.mspTitular3 = null">
                  <i class="fa-solid fa-trash"></i>
                </b-button>
                <a class="ml-2" v-if="fileUrlmspTitular3 && files.mspTitular3"
                  @click="openModalVer(fileUrlmspTitular3)">
                  <span>Ver nuevo</span></a>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </b-row>
    <b-modal id="modal-ver" size="xl">
      <b-card>
        <iframe :src="ruta" width="100%" height="500px"> </iframe>
      </b-card>
    </b-modal>
    <b-modal id="modal-olddocument" size="xl">
      <b-card>
        <iframe :src="urlolddocument" width="100%" height="500px"> </iframe>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import { titularService } from "../../services";

import rutas from "@/assets/utils/rutas.json";
export default {
  name: "EditMspsPaciente",

  components: {},

  props: {
    pacientetext: {
      required: false,
    },
    esimagenDerivada: {
      required: false,
      default: false,

    },
    esinformeimagen: {
      required: false,
      default: false,
    },
    objectMsps: {
      required: false,
      default: null,
    },
    esLaboratorioDerivado: {
      required: false,
      default: false,

    },
    paciente: {
      required: true,
    },
    itemCit: {
      required: false,
      default: null
    },
    esDerivado: {
      default: false,
      required: false,
    },
  },

  data() {
    return {
      ruta: null,
      urlolddocument: null,

      files: {
        derivacion: null,
        codigoDerivacion: null,
        f007: null,
        mspPaciente: null,
        mspTitular1: null,
        mspTitular2: null,
        mspTitular3: null,
        solicitudImagen: null,
        solicitudLaboratorio: null,
      },
      seguroPaciente: null,
      seguroMenor: false,

      fileUrlmspPaciente: null,
      fileUrlmspTitular1: null,
      fileUrlmspTitular2: null,
      fileUrlmspTitular3: null,
      filederivacion: null,
      file007: null,
      filecodDerivacion: null,
      fileSolicitudImagen: null,
      fileSolicitudLaboratorio: null,

      oldfileUrlmspPaciente: null,
      oldfileUrlmspTitular1: null,
      oldfileUrlmspTitular2: null,
      oldfileUrlmspTitular3: null,
      oldfilederivacion: null,
      oldfile007: null,
      oldfilecodDerivacion: null,
      oldfileSolicitudImagen: null,
      oldfileSolicitudLaboratorio: null,
      segurosMenores: ["AG", "CA", "HJ", "MH", "MO"],
      mspTitulares: [],
    };
  },

  async created() {
    let idPaciente = this.paciente;
    const onLoadTitulares = await titularService.getTitularesByIdPaciente(
      idPaciente
    );
    await this.loadMspForm(onLoadTitulares.titulares);
    this.$store.commit("setFiles", this.files);
  },
  methods: {
    async loadMspForm(titulares) {
      //console.log("titulares son estos", titulares, this.paciente)
      if (titulares && titulares.length > 0) {
        titulares.forEach((item) => {
          if (
            item.paciente.persona.identificacion !== item.persona.identificacion
          )
            if (this.mspTitulares.length > 0) {
              this.mspTitulares.forEach((msp) => {
                if (msp.identificacion !== item.persona.identificacion) {
                  this.mspTitulares.push(item.persona);
                }
              });
            } else {
              this.mspTitulares.push(item.persona);
            }
        });
      }
      await this.fillDocuments();
    },
    // async loadMspForm(titulares) {
    //   if (titulares && titulares.length > 0) {
    //     titulares.forEach(item => {
    //       //if(this.paciente.identificacion !== item.persona.identificacion) {}
    //         if(this.mspTitulares.length > 0){

    //           this.mspTitulares.forEach(msp => {
    //             console.log("msp", msp)
    //              if (msp.identificacion !== item.persona.identificacion) {
    //                 this.mspTitulares.push(item.persona)
    //              }
    //           })
    //         }else {
    //           this.mspTitulares.push(item.persona)

    //         }

    //     })
    //   }
    //   await this.fillDocuments()
    // },
    redirectToMSP() {
      const url = "https://coberturasalud.msp.gob.ec/";
      window.open(url, "_blank");
    },
    fillDocuments() {
      if (this.itemCit) {
        const {
          urlmsppac,
          urlmsptit1,
          urlmsptit2,
          urlmsptit3,
          urlDerivacion,
          urlCodDerivacion,
          urlSolicitudImagen,
          urlSolicitudLaboratorio,
          url007Recibido,
        } = this.itemCit;



        (this.oldfilederivacion = urlDerivacion ? urlDerivacion : ""),
          (this.oldfilecodDerivacion = urlCodDerivacion ? urlCodDerivacion : ""),
          (this.oldfile007 = url007Recibido || ""),

          (this.oldfileUrlmspPaciente = urlmsppac ? urlmsppac : ""),
          (this.oldfileUrlmspTitular1 = urlmsptit1 ? urlmsptit1 : ""),
          (this.oldfileUrlmspTitular2 = urlmsptit2 ? urlmsptit2 : ""),
          (this.oldfileUrlmspTitular3 = urlmsptit3 ? urlmsptit3 : "");


        (this.oldfileSolicitudImagen = urlSolicitudImagen ? urlSolicitudImagen : "");
        (this.oldfileSolicitudLaboratorio = urlSolicitudLaboratorio ? urlSolicitudLaboratorio : "");
      }
      if (this.objectMsps && this.esinformeimagen) {
        console.log("entra aqui", this.objectMsps)
        this.oldfileUrlmspPaciente = this.objectMsps.urlMsp
        this.oldfileUrlmspTitular1 = this.objectMsps.urlMspTitular1
        this.oldfileUrlmspTitular2 = this.objectMsps.urlMspTitular2
        this.oldfileUrlmspTitular3 = this.objectMsps.urlMspTitular3
      }

    },
    async descargarDocumento(tipodocument) {
      let downloadUrl = "";
      if (tipodocument === "der") {
        downloadUrl = this.oldfilederivacion;
      } else if (tipodocument === "codder") {
        downloadUrl = this.oldfilecodDerivacion;
      } else if (tipodocument === "msppac") {
        downloadUrl = this.oldfileUrlmspPaciente;
      } else if (tipodocument === "msptit1") {
        downloadUrl = this.oldfileUrlmspTitular1;
      } else if (tipodocument === "msptit2") {
        downloadUrl = this.oldfileUrlmspTitular2;
      } else if (tipodocument === "msptit3") {
        downloadUrl = this.oldfileUrlmspTitular3;
      } else if (tipodocument === "solimg") {
        downloadUrl = this.oldfileSolicitudImagen;
      } else if (tipodocument === "sollab") {
        downloadUrl = this.oldfileSolicitudLaboratorio;
      } else if (tipodocument === "007") {
        downloadUrl = this.oldfile007;
      } else {
        downloadUrl = "";
      }
      if (downloadUrl) {
        const fileName = decodeURIComponent(downloadUrl);
        const fullDownloadUrl = `${rutas.axios}file/show${fileName}`;
        try {
          this.urlolddocument = fullDownloadUrl;
          console.log(this.urlolddocument);
          this.$bvModal.show("modal-olddocument");
        } catch (error) {
          this.$swal({
            title: "Error",
            text: "Un error ocurrio mientras descarga el archivo",
            icon: "error",
            confirmButtonText: "Entendido",
          });
        }
      } else {
        this.$swal({
          title: "Campos vacíos",
          text: "El archivo no ha sido subido, por favor actualizar en editar admision",
          icon: "error",
          confirmButtonText: "Entendido",
        });
      }
    },

    openModalVer(ruta) {
      this.ruta = ruta;
      this.$bvModal.show("modal-ver");
    },
    onFileChange(event, posicion) {
      const file = event.target.files[0];
      if (file) {
        if (posicion === "msp") {
          this.fileUrlmspPaciente = URL.createObjectURL(file);
        }
        if (posicion === "mspt1") {
          this.fileUrlmspTitular1 = URL.createObjectURL(file);
        }
        if (posicion === "mspt2") {
          this.fileUrlmspTitular2 = URL.createObjectURL(file);
        }
        if (posicion === "mspt3") {
          this.fileUrlmspTitular3 = URL.createObjectURL(file);
        }
        if (posicion === "der") {
          this.filederivacion = URL.createObjectURL(file);
        }
        if (posicion === "solimg") {
          this.fileSolicitudImagen = URL.createObjectURL(file);
        }
        if (posicion === "codder") {
          this.filecodDerivacion = URL.createObjectURL(file);
        }
        if (posicion === "007") {
          this.file007 = URL.createObjectURL(file);
        }
      }
    },
    uploadFilesToVuexSt() {
      let files = this.files;
      this.$store.commit("setFiles", files);
    },
  },

  watch: {
    files: {
      handler(newValue) {
        if (newValue) {
          this.uploadFilesToVuexSt();
        }
      },
      deep: true,
    },
  },
};
</script>
